<template>
  <el-config-provider :locale="locale">
    <router-view></router-view>
  </el-config-provider>
</template>
<script >
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
export default {
  setup () {
    let locale = zhCn;
    return {
      locale
    };
  },
};
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: PingFang SC,Microsoft YaHei,Arial,sans-serif,Helvetica Neue,Helvetica,Hiragino Sans GB !important;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: #f0f2f3;
}

.ql-editor{
  padding: 0 !important;
}
.ql-editor ol{
  padding-left:0px !important;
}
.ql-editor ul {
  padding-left:0px  !important;
}
</style>
